import React, { useEffect, useState } from 'react';
import { Size, SideMenu } from '@laerdal/life-react-components';
import styled from 'styled-components';
import i18next from '../../i18n';

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: #00000080;
  display: flex;
  justify-content: right;
  top: 0;
  left: 0;
`;

const IFrame = styled.iframe`
  width: 100%;
`

const SideContainer = styled(SideMenu)`
  & > div:first-child {
    margin-left: 16px;
  }

  & > div {
    padding: 0;
  }
`

const getInnerText = (selector: string) : string => {
  const elements = document.querySelectorAll(selector);
  let result = '';
  for(let i = 0; i < elements.length; i++)
  {
    if(i>0)
      result += ';';
    //@ts-ignore
    result += elements[i].innerText;
  }

  return result;
}


const useClickOutsideRef = (callback: () => void, relatedRefs: any[] = [], ref?: any) => {
  const elementRef = ref ?? React.useRef<any>(null);

  React.useEffect(() => {
    if (!elementRef.current) return;
    let container = elementRef.current;

    const handleClickOutside = (event: any) => {
      if (container 
        && (event.clientX < document.documentElement.offsetWidth) //does not trigger if you click on browser scroll
        && !container.contains(event.target) 
        && !relatedRefs.some(ref => ref.current 
        && ref.current.contains(event.target))) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };

  }, [elementRef, relatedRefs]);

  return elementRef;
};


export interface HelpUProps {
  title?: string;
  product?: string | string[];
  locale?: string;
  env?: string;
  authToken?: string;
  releaseNotesId?: string;
  source: 'helpjuice' | 'salesforce';
  isOpen: boolean;
}

export const HelpUComponent = ({ releaseNotesId, source, title, product, locale, isOpen, authToken, env }: HelpUProps) => {

  useEffect(() => {
    if (!!locale) i18next.changeLanguage(locale.toLowerCase());
    else i18next.changeLanguage('en');
  }, [locale]);

  const [showMenu, setShowMenu] = useState<boolean>(isOpen);
  const [url, setUrl] = useState<string>('');

  const wrapperRef = React.useRef<any>(null);

  const getBase64Safe = (plainText: string) => {
    try{
      return window.btoa(plainText)
    }
    catch
    {
      return '';
    }
  };

  const containerRef = useClickOutsideRef(() => {
    //@ts-ignore
    document.getElementById('helpuFrame').contentWindow.postMessage('closingHelpU', '*');

    //this is in a timeout so the above message can be processed in the iFrame
    setTimeout(() => {
      setShowMenu(false);
    }, 20);
  }, [wrapperRef]);

  useEffect(() => {
    const header = getInnerText("header");
    const h1Text = getInnerText("h1");
    const h2Text = getInnerText("h2");
    const h3Text = getInnerText("h3");
    const h4Text = getInnerText("h4");
    const h5Text = getInnerText("h5");
    const h6Text = getInnerText("h6");
    
    let helpU = ``;

    if(env == 'dev')
      helpU = `https://helpu-dev.laerdal.com/embeded/search?`;
    else if(env == 'test')
      helpU = `https://helpu-test.laerdal.com/embeded/search?`;
    else
      helpU = `https://helpu.laerdal.com/embeded/search?`;
    
    if(!!product){
      if(Array.isArray(product))
        helpU += `&product=${product.join(',')}`;
      else
        helpU += `&product=${product}`;
    } 
      
    if(!!locale) helpU += `&locale=${locale}`;
    if(!!authToken) helpU += `&token=${authToken}`;
    if(!!releaseNotesId) helpU += `&releaseNotes=${releaseNotesId}`;
    if(!!source) helpU += `&source=${source}`;
    
    if(!!header) helpU += `&h=${getBase64Safe(header)}`;
    if(!!h1Text) helpU += `&h1=${getBase64Safe(h1Text)}`;
    if(!!h2Text) helpU += `&h2=${getBase64Safe(h2Text)}`;
    if(!!h3Text) helpU += `&h3=${getBase64Safe(h3Text)}`;
    if(!!h4Text) helpU += `&h4=${getBase64Safe(h4Text)}`;
    if(!!h5Text) helpU += `&h5=${getBase64Safe(h5Text)}`;
    if(!!h6Text) helpU += `&h6=${getBase64Safe(h6Text)}`;
    
    helpU += `&src=${getBase64Safe(document.location.href)}`

    setUrl(helpU);
  }, [releaseNotesId, source, title, product, locale, isOpen, authToken]);

  return (
    <>
      {showMenu && <Overlay >
        <div ref={containerRef}>
          <SideContainer header={{label: !title ? "SimCapture Help" : title}}  size={Size.Large} onClose={() => {
              //@ts-ignore
              document.getElementById('helpuFrame').contentWindow.postMessage('closingHelpU', '*');

              //this is in a timeout so the above message can be processed in the iFrame
              setTimeout(() => {
                setShowMenu(false);
              }, 20);
            }}>
            <IFrame id="helpuFrame" frameBorder={0} src={url} />
          </SideContainer>
        </div>
      </Overlay>}
    </>
  );
};
